











import { Specification } from '~/models/classified/types'
import { faCheck, faClipboard } from '@fortawesome/free-solid-svg-icons'
import { copyTextToClipboard } from '~/utils/dom'
import { defineComponent, PropType } from '@nuxtjs/composition-api'

export default defineComponent({
  props: {
    specification: {
      type: Object as PropType<Specification>,
      required: true
    }
  },
  data() {
    return {
      icons: {
        clipboard: faClipboard,
        checkmark: faCheck
      },
      copied: false
    }
  },
  computed: {
    displayLink() {
      return this.specification.value.replace(/(^\w+:|^)\/\//, '')
    }
  },
  methods: {
    linkClicked(e) {
      if (!this.copied) {
        e.preventDefault()
        this.copy()
      }
    },
    copy() {
      if (this.copied) {
        return
      }
      copyTextToClipboard(this.specification.value)
      this.$snackbar.success(this.$t('link copied to clipboard'))
      this.copied = true
    }
  }
})
